<template>
<v-app>
    <v-app-bar flat app height="90" color="transparent">
      <v-spacer></v-spacer>
      <a href="https://pappyon.com/">
      <img class="mr-2" src="../assets/header-logo.svg" height="70"/>
      </a>
    </v-app-bar>
    <v-main>
      <v-container class="pa-0" fluid>
        <slot/>
        <v-footer padless absolute="" color="transparent">
          <v-col
            class="text-center"
            cols="12"
          >
            <span class="text-caption grey--text"> © Pappyon Pty Ltd {{ new Date().getFullYear() }}</span>
            <a class="text-caption grey--text mx-8 text-decoration-none" @click="openContactUrl">Contact</a>
            <a class="text-caption grey--text text-decoration-none" @click="openPrivacyPolicyUrl()">Privacy & Terms</a>
          </v-col>
        </v-footer>
      </v-container>
    </v-main>
</v-app>
</template>
<script>

import {mapGetters, mapActions} from 'vuex'
import {onSnapshot, where} from "firebase/firestore";
import {queryBusinessCardsCollection} from "@/shared/firebase_utils";
export default {
    data: () => ({
       unsubscrbeCardHoldersSnapshot: null,
    }),
    computed: {
        ...mapGetters(['userProfile', 'contactUrl', 'openPrivacyPolicyUrl']),
    },
    created() {
        this.clearCardholders();
        this.unsubscrbeCardHoldersSnapshot =
        onSnapshot(
            queryBusinessCardsCollection(where('businessProfileId', '==', this.userProfile.businessProfileId)),

            (response)=>{
            const changes = response.docChanges(); 
            this.onCardHoldersSnapshot(changes);
        });
    },
    destroyed() {
        this.unsubscrbeCardHoldersSnapshot();
        this.clearCardholders();
    },
    methods: {
        ...mapActions(['onCardHoldersSnapshot', 'clearCardholders']),
        openContactUrl() {
          window.open(this.contactUrl);
        },
        openPrivacyPolicyUrl() {
            window.open(this.privacyPolicyUrl);
        },
    }
}
</script>